// extracted by mini-css-extract-plugin
export default {"root":"SignInModal_root__Me+4X","header":"SignInModal_header__caome","count":"SignInModal_count__KpLCh","button":"SignInModal_button__IZViF","space":"SignInModal_space__bRhQ8"};